import { WidgetValuesProvider } from '../../../common/services/WidgetValuesProvider';
import { SourceModelBase } from '..';
import { CustomLinkedSource, CustomSourceData } from '../../../custom_shared/types';
import { Filter } from '../../../common/services/SessionService';
import { Utils } from '../../misc';

export default class LinkedSourceModel extends SourceModelBase {
    readonly link: string;

    constructor(
        data: CustomLinkedSource,
        readonly widgetValuesProvider: WidgetValuesProvider
    ) {
        super(data);

        this.link = data.link;
    }

    async getSources(ignoreCache?: boolean, filter?: Filter): Promise<CustomSourceData[]> {
        const widgetData = await this.widgetValuesProvider.fetchAll(ignoreCache, filter, this.handleError);
        return this.filterData(widgetData.data);
    }

    async getSourcesByParent(parentValues: unknown): Promise<CustomSourceData[]> {
        const widgetData = await this.widgetValuesProvider.fetchAllByParent(
            Utils.convertToStringArray(parentValues),
            true,
            this.handleError
        );

        return this.filterData(widgetData.data);
    }

    private handleError(error: string) {
        throw new Error(error);
    }
}
